import { BaseApi } from "api/BaseApi.ts";

import GetCurrenciesResponse = App.Http.Responses.Currency.GetCurrenciesResponse;
import GetCurrencyResponse = App.Http.Responses.Currency.GetCurrencyResponse;

class CurrencyApi extends BaseApi {
    async index(): Promise<GetCurrenciesResponse> {
        return this.get<GetCurrenciesResponse, void>("/currencies");
    }

    async show(currencyId: string): Promise<GetCurrencyResponse> {
        return this.get<GetCurrencyResponse, void>(`/currencies/${currencyId}`);
    }
}

export const currencyApi = new CurrencyApi();
